export default __webpack_public_path__ + "static/0213-8296fb46fe1b02562d9a87faae319ac4.png";